import React from 'react';


// Full class strings only — Tailwind's JIT can't see dynamically built names.
export const TONES = {
  primary: { icon: 'text-primary-700', bg: 'bg-primary-50', bar: 'bg-primary-700/10 group-hover:bg-primary-700' },
  emerald: { icon: 'text-emerald-600', bg: 'bg-emerald-50', bar: 'bg-emerald-600/10 group-hover:bg-emerald-600' },
  green:   { icon: 'text-green-600',   bg: 'bg-green-50',   bar: 'bg-green-600/10 group-hover:bg-green-600' },
  blue:    { icon: 'text-blue-700',    bg: 'bg-blue-50',    bar: 'bg-blue-700/10 group-hover:bg-blue-700' },
  sky:     { icon: 'text-sky-600',     bg: 'bg-sky-50',     bar: 'bg-sky-600/10 group-hover:bg-sky-600' },
  indigo:  { icon: 'text-indigo-600',  bg: 'bg-indigo-50',  bar: 'bg-indigo-600/10 group-hover:bg-indigo-600' },
  violet:  { icon: 'text-violet-600',  bg: 'bg-violet-50',  bar: 'bg-violet-600/10 group-hover:bg-violet-600' },
  amber:   { icon: 'text-amber-600',   bg: 'bg-amber-50',   bar: 'bg-amber-600/10 group-hover:bg-amber-600' },
  orange:  { icon: 'text-orange-600',  bg: 'bg-orange-50',  bar: 'bg-orange-600/10 group-hover:bg-orange-600' },
  red:     { icon: 'text-red-600',     bg: 'bg-red-50',     bar: 'bg-red-600/10 group-hover:bg-red-600' },
  rose:    { icon: 'text-rose-600',    bg: 'bg-rose-50',    bar: 'bg-rose-600/10 group-hover:bg-rose-600' },
};

export default function StatCard({ label, value, sub, icon: Icon, tone = 'primary', accent = true }) {
  const t = TONES[tone] || TONES.primary;

  return (
    <div className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group flex flex-col">
      {/* Two lines of label height are always reserved, so a card whose label
          wraps ("Pending Requests") lines up with one that doesn't ("Approved"). */}
      <div className="flex justify-between items-start gap-2 mb-1.5 min-h-[28px]">
        <h3 className="text-[11px] font-semibold text-gray-500 tracking-wider leading-[14px]">{label}</h3>
        {Icon && (
          <span className={`${t.icon} ${t.bg} p-1 rounded-md flex items-center justify-center shrink-0`}>
            <Icon size={14} />
          </span>
        )}
      </div>

      {/* mt-auto pins the figure + caption to the bottom, so the values sit on
          one line across the row even if a label ever runs to three lines. */}
      <div className="mt-auto">
        <div className="text-2xl font-bold text-gray-900 tracking-tight leading-8">{value}</div>
        <p className="text-[11px] text-gray-400 mt-0.5 truncate leading-4 min-h-[16px]">{sub || ' '}</p>
      </div>

      {accent && <div className={`absolute bottom-0 left-0 w-full h-0.5 transition-colors ${t.bar}`} />}
    </div>
  );
}